import classes from "./SettingsItem.module.scss";
import { Card } from "../../common/card/Card";

export interface SettingsItemProps {
  icon?: string;
  title?: string;
  secondaryText?: string;
  clickHandler?: any;
  dataTestId?: string;
}

export const SettingsItem: React.FC<SettingsItemProps> = ({
  icon = "account_balance",
  title = "",
  secondaryText = "",
  clickHandler,
  dataTestId,
}) => {
  return (
    <button
      type="button"
      className={classes.SettingsItem}
      onClick={clickHandler}
      data-testid={dataTestId}
    >
      <Card title=" " showDivider={false}>
        <div className={classes.ItemWrapper}>
          <div className={classes.IconWrapper}>
            <ft-icon>{icon}</ft-icon>
          </div>
          <h3>
            {title}
            <p> {secondaryText}</p>
          </h3>
        </div>
      </Card>
    </button>
  );
};
